import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useDeviationViewContext } from '../../../Context';

import s from './DeviationPageLoader.scss';

export interface Props {}

export const DeviationPageLoader: React.FC<Props> = () => {
  const { isFullscreen } = useDeviationViewContext();
  return (
    <div className={classnames(s['root'], isFullscreen && s['fullscreen'])}>
      <LoadingIndicator view="llama" className={s['lloader']} />
    </div>
  );
};
DeviationPageLoader.displayName = 'DeviationPageLoader';

export default DeviationPageLoader;
